import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { constants } from "@lib/constants";

// Initial state
const initialState = {
  profileDetails: null,
  profileDetailsIsLoading: true,

  allCollections:[],
  collectionsLoading:true,

  allCities:[],
  citiesLoading:false,

  socialData: [],
  socialLoading: null,

  defaultProfileType: null,
  actorProfileData: null,
  modalProfileData: null,
  voiceOverProfileData: null,

  profileTypeOptions: [],
  categories: [],
  subcategories: {},
  allCategories:[],
  loading: false,

  // ✅ NEW
  savedProfiles: [],
  savedProfilesLoading: false,

  allProfiles: [],
  allProfilesTotalCount: 0,
  allProfilesLoading: false,

  profileDataBySlug: null,
  profileDataBySlugLoading: false,
};


// Fetch profile details thunk
export const fetchProfileDetails = createAsyncThunk(

  "profileReducer/fetchProfileDetails",
  async ({ axiosGet, params }, thunkAPI) => {
    try {
      const response = await axiosGet(`${constants.GET_PROFILE_DETAILS}/${params}`);
      return {
        data: response.data,
        totalCount: response.data, // Redundant?
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Fetch profile details thunk
export const fetchSocials = createAsyncThunk(
  "profileReducer/fetchSocials",
  async ({ axiosGet, userId }, thunkAPI) => {
    try {
      const response = await axiosGet(`social/list/${userId}`);
      return {
        data: response.data,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Fetch categories (excluding already added categories)
export const fetchCategories = createAsyncThunk(
  "profileReducer/fetchCategories",
  async ({ axiosGet  }, thunkAPI) => {
    try {
      const response = await axiosGet(constants.GET_ARTIST_TYPE);
      if (
        response?.status === "success" &&
        Array.isArray(response?.data?.records)
      ) {
        const state = thunkAPI.getState().profileReducer;
        const existingTitles = state.profileDetails?.profiles?.map((p) => p?.artistCategory?.title) || [];

        const filtered = response.data.records.filter(
          (item) => !existingTitles.includes(item?.title)
        );

        return {filtered,all:response?.data?.records || []};
      }
      return [];
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Fetch Saved Profiles on User Profile
export const fetchSavedProfiles = createAsyncThunk(
  "profileReducer/fetchSavedProfiles",
  async ({ axiosGet, userId }, thunkAPI) => {
    try {
      const res = await axiosGet(
        `profile/list/saved?userId=${userId}`
      );
      return res.data?.data || [];
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const fetchCollections = createAsyncThunk(
  "profileReducer/fetchCollections",
  async ({ axiosGet, userId }, thunkAPI) => {
    try {
      const res = await axiosGet(`profile/artist/collections/${userId}`);
      return res.data || [];
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Fetch Profile List for user ID
export const fetchAllProfiles = createAsyncThunk(
  "profileReducer/fetchAllProfiles",
  async (
    { axiosGet,userId, params},
    thunkAPI
  ) => {
    try {
      const { data } =
 await axiosGet(
  `profile/artist/list/${userId}${
    params
      ? `?${params}`
      : ""
  }`
);
      return {
        records: data?.records || [],
        count: data?.count || 0,
      };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const fetchCities = createAsyncThunk(
  "profileReducer/fetchCities",
  async ( {axiosGet,countryCode}, thunkAPI
  ) => {
    try {
      const data = await axiosGet(`${constants.BASE_URL}location/cities/${countryCode}`);
      return data
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Fetch Data by Slug
export const fetchProfileDataBySlug = createAsyncThunk(
  "profileReducer/fetchProfileDataBySlug",
  async ({ axiosGet, slug }, thunkAPI) => {
    try {
      const response = await axiosGet(`public/profile/${slug}`);
      return response.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);



// Slice
const profileReducer = createSlice({
  name: "profileReducer",
  initialState,
  reducers: {
    setDefaultProfileType: (state, action) => {
      state.defaultProfileType = action.payload;
    },
    setProfileTypeOptions: (state, action) => {
      state.profileTypeOptions = action.payload;
    },
    setSubcategories: (state, action) => {
      const { categoryId, subcategories } = action.payload;
      state.subcategories[categoryId] = subcategories;
    },
    clearSubcategories: (state) => {
      state.subcategories = {};
    },
  },
  extraReducers: (builder) => {
  builder

    // ===============================
    // Profile Details
    // ===============================
    .addCase(fetchProfileDetails.pending, (state,) => {
      
      state.profileDetailsIsLoading = true;
    })
    .addCase(fetchProfileDetails.fulfilled, (state, action) => {
       console.log("fullfilled",action.payload)
      state.profileDetails = action.payload.data;
      state.profileDetailsIsLoading = false;
    })
    .addCase(fetchProfileDetails.rejected, (state) => {
      console.log("rejected");
      state.profileDetailsIsLoading = false;
    })

    // ===============================
    // Socials
    // ===============================
    .addCase(fetchSocials.pending, (state) => {
      state.socialLoading = true;
    })
    .addCase(fetchSocials.fulfilled, (state, action) => {
      state.socialData = action.payload.data;
      state.socialLoading = false;
    })
    .addCase(fetchSocials.rejected, (state) => {
      state.socialLoading = false;
    })

    // ===============================
    // Categories
    // ===============================
    .addCase(fetchCategories.pending, (state) => {
      state.loading = true;
      state.allCategories=[];

    })
    .addCase(fetchCategories.fulfilled, (state, action) => {
      state.categories = action.payload.filtered;
      state.allCategories=action.payload.all;

      state.loading = false;
    })
    .addCase(fetchCategories.rejected, (state) => {
      state.categories = [];
      state.allCategories=[];
      state.loading = false;
    })

    // ===============================
    // ✅ Saved Profiles
    // ===============================
    .addCase(fetchSavedProfiles.pending, (state) => {
      state.savedProfilesLoading = true;
    })
    .addCase(fetchSavedProfiles.fulfilled, (state, action) => {
      state.savedProfiles = action.payload;
      state.savedProfilesLoading = false;
    })
    .addCase(fetchSavedProfiles.rejected, (state) => {
      state.savedProfilesLoading = false;
    })

    // ===============================
    // ✅ All Profiles
    // ===============================
    .addCase(fetchAllProfiles.pending, (state) => {
      state.allProfilesLoading = true;
    })
    .addCase(fetchAllProfiles.fulfilled, (state, action) => {
      state.allProfiles = action.payload.records;
      state.allProfilesTotalCount = action.payload.count;
      state.allProfilesLoading = false;
    })
    .addCase(fetchAllProfiles.rejected, (state) => {
      state.allProfilesLoading = false;
    })

    // ===============================
    // ✅ All Collections
    // ===============================
    .addCase(fetchCollections.pending, (state) => {
      state.collectionsLoading = true;
    })
    .addCase(fetchCollections.fulfilled, (state, action) => {
      state.allCollections = action.payload.collections;
      state.collectionsLoading = false;
    })
    .addCase(fetchCollections.rejected, (state) => {
      state.collectionsLoading = false;
    })

    // Fetch Cities

    .addCase(fetchCities.pending, (state) => {
      state.citiesLoading = true;
    })
    .addCase(fetchCities.fulfilled, (state, action) => {
      state.allCities = action.payload;
      state.citiesLoading = false;
    })
    .addCase(fetchCities.rejected, (state) => {
      state.citiesLoading = false;
    })

    // ===============================
    // ✅ Profile By Slug
    // ===============================
    .addCase(fetchProfileDataBySlug.pending, (state) => {
      state.profileDataBySlugLoading = true;
    })
    .addCase(fetchProfileDataBySlug.fulfilled, (state, action) => {
      state.profileDataBySlug = action.payload;
      state.profileDataBySlugLoading = false;
    })
    .addCase(fetchProfileDataBySlug.rejected, (state) => {
      state.profileDataBySlugLoading = false;
    });
}

});

// Exports
export const {
  setSubcategories,
  clearSubcategories,
  setDefaultProfileType,
  setProfileTypeOptions,
} = profileReducer.actions;

export default profileReducer.reducer;
